import { useSelector } from "react-redux";
import type { RootState } from "@src/reducers/store";

export const useIsImmacNamespace = (): boolean => {
  const namespace = useSelector(
    (state: RootState) => state.yourSlice.authContext?.customerNamespace,
  );
  if (namespace) {
    return namespace === "a06a0feb-c7ac-4988-91ea-37e6d082bf8d";
  }
  return false;
};
